import React, { useState } from 'react';
import { Briefcase, Calendar, Building } from 'lucide-react';
import { portfolioData } from '../data/mock';

export const Portfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState('Semua');
  
  const categories = ['Semua', 'Hukum Administrasi Negara', 'Hukum Teknologi Informasi', 
                     'Hukum Lingkungan', 'Hukum Bisnis', 'Hukum Ketenagakerjaan'];

  const filteredPortfolio = selectedCategory === 'Semua' 
    ? portfolioData 
    : portfolioData.filter(item => item.category === selectedCategory);

  return (
    <section id="portfolio" className="py-20 px-4" style={{ background: 'var(--bg-section)' }}>
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Portfolio Kami</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Proyek dan kasus yang telah kami tangani dengan hasil yang memuaskan
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-3 justify-center mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`btn-tag ${selectedCategory === category ? 'active' : ''}`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredPortfolio.map((item) => (
            <div key={item.id} className="voice-card hover-lift">
              {/* Category Badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-4" 
                   style={{ 
                     background: 'var(--accent-purple-200)',
                     border: '1px solid var(--accent-purple-400)'
                   }}>
                <Briefcase size={14} style={{ color: 'var(--accent-purple-400)' }} />
                <span className="caption" style={{ color: 'var(--accent-purple-400)', fontWeight: 500 }}>
                  {item.category}
                </span>
              </div>

              {/* Title */}
              <h3 className="heading-3 mb-3">{item.title}</h3>

              {/* Description */}
              <p className="body-small mb-4" style={{ color: 'var(--text-secondary)' }}>
                {item.description}
              </p>

              {/* Meta Info */}
              <div className="flex items-center gap-4 pt-4 border-t" style={{ borderColor: 'var(--border-light)' }}>
                <div className="flex items-center gap-2">
                  <Calendar size={14} style={{ color: 'var(--text-muted)' }} />
                  <span className="caption" style={{ color: 'var(--text-muted)' }}>{item.year}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Building size={14} style={{ color: 'var(--text-muted)' }} />
                  <span className="caption" style={{ color: 'var(--text-muted)' }}>{item.client}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
